export default "__VITE_ASSET__DRN8GgNA__"